<template>
  <div class="bg-light-50 text-light-950 dark:bg-dark-950 dark:text-dark-50 min-h-svh">
    <div class="relative bg-light-200 dark:bg-dark-920">
      <img :src="bannerGradientDark" class="absolute top-0 left-0 w-full h-full opacity-80 hidden dark:block" />
      <img :src="bannerGradient" class="absolute top-0 left-0 w-full h-full opacity-80 dark:hidden" />

      <div class="h-full absolute top-0 left-0 bg-gradient-to-r w-2/5 from-light-100 dark:from-dark-950 to-light-100/0 dark:to-dark-950/0 hidden sm:block" />
      <div class="h-full absolute top-0 right-0 bg-gradient-to-l w-2/5 from-light-100 dark:from-dark-950 to-light-100/0 dark:to-dark-950/0 hidden sm:block" />

      <div class="max-w-wrapper-xs mx-auto px-3 relative">        
        <div class="flex items-center relative space-x-3 h-20">
          <NuxtLink :to="'/'" class="flex items-center space-x-1.5 shrink-0">
            <img :src="logoVibesDark" class="h-6 hidden dark:block">
            <img :src="logoVibesDark" class="h-6 dark:hidden">

            <img src="assets/img/flags/lgbtqia_animated_xl.png" class="h-7" />
          </NuxtLink>

          <div class="grow" />

          <!-- <ButtonLink :to="useRuntimeConfig().public.APP_URL" class="hidden sm:flex">
            {{ $t('actions.login') }}
          </ButtonLink>

          <ButtonBase color="builders" size="sm" :to="useRuntimeConfig().public.APP_URL" class="hidden sm:flex">
            {{ $t('actions.register') }}
          </ButtonBase> -->
          <ButtonBase size="sm" :href="useRuntimeConfig().public.APP_URL" color="white" v-if="currentUser">
            <UserPicture :user="currentUser" size="sm" class="-ml-3 mr-2" />
            {{ currentUser?.name ? currentUser?.name : currentUser?.email }}
          </ButtonBase>
          <ButtonBase size="sm" :to="{ query: { join: 'true' }}" color="builders" v-else>
            Rejoindre Vibes
          </ButtonBase>
        </div>
        <div class="overflow-auto no-scrollbar -mx-3 px-3">
          <div class="flex items-center space-x-3">
            <NuxtLink
              class="pb-2 px-1 space-x-1.5 shrink-0 flex text-white items-center font-bold border-b-2"
              v-for="item in nav"
              :to="item.to"
              :class="[
                item.to.name === (route.name ?? '') ? ' border-white' : ' opacity-80 border-transparent'
              ]"
            >
                <IconBase :name="item.icon + (item.to.name === (route.name ?? '') ? '-fill' : '')" />
                <p class="grow font-bold">
                  {{ item.label }}
                </p>
            </NuxtLink>

            <div class="w-12 h-1 shrink-0" />
          </div>
        </div>
      </div>
    </div>

    <div>
      <slot />
    </div>
    
    <footer class="bg-light-200 dark:bg-dark-850 p-8 relative">
      <div class="max-w-wrapper-lg mx-auto px-6 md:flex space-y-8 md:space-y-0 md:space-x-8 relative z-10">
        <div class="md:pr-8">
          <img src="@/assets/img/logo/logo-square.png" class="w-20 rounded-2xl">
        </div>

        <div class="flex-1 shrink-0 space-y-6" v-for="(column, i) in columns" :key="i">
          <div v-for="(section, j) in column" :key="j">
            <p class="font-bold text-lg mb-2">{{ section.title }}</p>

            <div class="space-y-1">
              <div v-for="(link, k) in section.items" :key="k">
                <ButtonLink class="cursor-pointer hover:underline" v-bind="link" is-invert> 
                  {{ link.label }}
                </ButtonLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>

    <PopinBase :is-active="route?.query?.join ? true : false" @close="() => router.push({ query: { join: undefined }})" size="3xs">
      <template #body>
        <div class="text-center relative">
          <div class=" h-96 relative">
            <video autoplay loop muted playsinline class="absolute top-0 left-0 h-full w-full object-cover object-center">
              <source src="@/assets/videos/intro.mp4" type="video/mp4" />
            </video>

            <div class="absolute left-0 right-0 -bottom-1 h-1/2 bg-gradient-to-t from-light-50 dark:from-dark-920 to-light-50/0 dark:to-dark-920/0" />
          </div>
          
          <div class="relative p-6 -mt-32">
            <img src="assets/img/logo/logo-square.png" class="size-16 rounded-xl mx-auto shrink-0" />

            <p class="text-3xl font-bold mt-4">Rejoins Vibes et fais des rencontres LGBTQIA+</p>

            <div class="flex items-center justify-center mt-3">
              <IconBase name="cute/star-fill" :width="16" />
              <IconBase name="cute/star-fill" :width="16" />
              <IconBase name="cute/star-fill" :width="16" />
              <IconBase name="cute/star-fill" :width="16" />
              <IconBase name="cute/star-half-fill" :width="16" />
            </div>

            <p class="font-bold text-lg mt-1">
              <NumberFlow :value="count" :locales="'fr'" /> membres
            </p>

            <ButtonBase :href="auto" color="base" class="mt-4">
              Télécharger l'application
            </ButtonBase>

            <div class="mt-2 hidden sm:block">
              <ButtonLink :to="useRuntimeConfig().public.APP_URL">
                Version web
              </ButtonLink>
            </div>
          </div>
        </div>
      </template>
    </PopinBase>

    <ToasterBase />
  </div>
</template>

<script lang="ts" setup>
import logoVibesDark from '@/assets/img/logo/logo-white.png'
import logoVibesLight from '@/assets/img/logo/logo-gradient.png'
import { getAppDownloadLink } from '@/utils/useApp'
import bannerGradient from '@/assets/img/gradients/hard/gradient-16.jpg'
import bannerGradientDark from '@/assets/img/gradients/hard/gradient-15.jpg'
import { mainUserCountGetAPI } from '~/api/main'
import NumberFlow from '@number-flow/vue'
import UserStore from '@/store/user'

const userStore = UserStore()
const { currentUser } = storeToRefs(userStore)


const { auto } = getAppDownloadLink()

const nav = computed(() => [
  {
    label: 'À la une',
    icon: 'cute/comment-2',
    to: { name: 'index' }
  },
  {
    label: 'Blog',
    icon: 'cute/pen',
    to: { name: 'blog' }
  },
  // {
  //   label: 'Sorties',
  //   icon: 'cute/calendar',
  //   to: { name: 'event' }
  // },
  // {
  //   label: 'Groupes',
  //   icon: 'cute/group',
  //   to: { name: 'event' }
  // },
  // {
  //   label: 'Membres',
  //   icon: 'cute/user-group',
  //   to: { name: 'event' }
  // }
])

const route = useRoute()
const router = useRouter()

const autoLink = ref('')
const iosLink = ref('')
const androidLink = ref('')

const count = ref(180000)
const interval = ref()

const columns = computed(() => [
  [
    {
      title: `À propos de Vibes`,
      items: [
        {
          label: `Page d'accueil`,
          to: '/'
        },
        {
          label: `Questions fréquentes`,
          to: { name: 'questions-frequentes' }
        },
        {
          label: `Le blog`,
          to: { name: 'blog' }
        }
      ]
    },
    {
      title: `Où faire des rencontres ?`,
      items: [
        {
          label: `Rencontres LGBT en France`,
          to: { name: 'france' }
        },
      ]
    },
    {
      title: `Les villes les plus animées`,
      items: [
        {
          label: `Rencontres LGBT à Paris`,
          to: { name: 'cities-city', params: { city: 'france-paris' } }
        },
        {
          label: `Rencontres LGBT à Marseille`,
          to: { name: 'cities-city', params: { city: 'france-marseille' } }
        },
        {
          label: `Rencontres LGBT à Toulouse`,
          to: { name: 'cities-city', params: { city: 'france-toulouse' } }
        },
        {
          label: `Rencontres LGBT à Genève`,
          to: { name: 'cities-city', params: { city: 'switzerland-geneva' } }
        },
        {
          label: `Rencontres LGBT à Strasbourg`,
          to: { name: 'cities-city', params: { city: 'france-strasbourg' } }
        }
      ]
    }
  ],
  [
    {
      title: `Nous rejoindre`,
      items: [
        {
          label: `Télécharger sur iOS`,
          href: iosLink.value
        },
        {
          label: `Télécharger sur Android`,
          href: androidLink.value
        },
        {
          label: `S'inscrire`,
          href: useRuntimeConfig().public.APP_URL
        }
      ]
    },
    {
      title: `Mentions légales`,
      items: [
        {
          label: `Charte Vibes`,
          to: { name: 'charte' }
        },
        {
          label: `Conditions d'utilisation`,
          to: { name: 'eula' }
        },
        {
          label: `Politique de confidentialité`,
          to: { name: 'privacy' }
        }
      ]
    }
  ],
  [
    {
      title: `Réseaux`,
      items: [
        {
          label: `Instagram`,
          href: 'https://www.instagram.com/vibes.lgbt'
        },
        {
          label: `Meetup Paris`,
          href: 'https://www.meetup.com/fr-FR/vibes-lgbtq-amities-rencontres'
        },
      ]
    },
    {
      title: `Partenaires`,
      items: [
        {
          label: `Investir dans Vibes`,
          to: { name: 'investors'}
        },
        {
          label: `Iels parlent de nous`,
          to: { name: 'press'}
        }
      ]
    }
  ]
])

onMounted(async () => {
  const { auto, ios, android } = getAppDownloadLink()

  autoLink.value = auto
  iosLink.value = ios
  androidLink.value = android

  const response = await mainUserCountGetAPI()
  if (response.ok) {
    count.value = response.data.count
  }

  if (interval.value) clearInterval(interval.value)
  interval.value = setInterval(async () => {
    if (!route?.query?.join) return

    const response = await mainUserCountGetAPI()
    if (response.ok) {
      count.value = response.data.count
    }
  }, 1000)
})

onBeforeUnmount(() => {
  if (interval.value) clearInterval(interval.value)
})

</script>